import React from 'react';
import { LoadingOutlined, CheckCircleTwoTone } from '@ant-design/icons';
import { Spin } from 'antd';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
const antCheck = (
  <CheckCircleTwoTone style={{ fontSize: 30 }} twoToneColor="#52c41a" />
);

export const VerifyModal = () => {
  return (
    <div className="modal-content-wrapper">
      <div className="modal-content-description">
        <Spin indicator={antIcon} size="large" />
      </div>
      <div className="button-container">
        <div className="modal-content-extra">
          Verifying your card now. It may take a while…
        </div>
      </div>
    </div>
  );
};

export const SuccessModal = () => {
  return (
    <div className="modal-content-wrapper">
      <div className="modal-content-description">{antCheck}</div>
      <div className="button-container">
        <div className="modal-content-extra">Success</div>
      </div>
    </div>
  );
};
